import { render, staticRenderFns } from "./UploadAttach.vue?vue&type=template&id=2f1b868c&scoped=true&"
import script from "./UploadAttach.vue?vue&type=script&lang=js&"
export * from "./UploadAttach.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttach.vue?vue&type=style&index=0&id=2f1b868c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1b868c",
  null
  
)

export default component.exports